import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import AdminTable from '../AdminTable';
import { fetchList, deleteEvents } from '../../../actions/admin/models/events';
import { MODELS } from '../../../constants/admin/settings';
import { BREADCRUMB } from '../../../constants/admin/breadcrumb';
import { withBreadcrumb } from '../../../components/admin/hocs/BreadcrumbWrapper';

class Index extends Component {
    render() {
        return (
            <AdminTable
                enableSearch={true}
                model={MODELS.EVENT}
                fetchDataFunction={this.props.fetchList}
                deleteAction={this.props.deleteEvents}
                pagination={true}
            />
        );
    }
}

const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch => bindActionCreators({ fetchList, deleteEvents }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(withBreadcrumb(Index, () => [BREADCRUMB.EVENTS]));
